module.exports = {
	"config": {
		"blogTitle": "The Sous Vide Diaries",
		"authorName": "Riley Tomasek"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/rltmsk/src/sous-vide-diaries/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "1-pork-chop",
				"base": "index.html",
				"ext": "html",
				"name": "index",
				"extname": ".html",
				"basename": "index.html",
				"dirname": "1-pork-chop",
				"stem": "index",
				"path": "1-pork-chop/index.html",
				"absolute": "/Users/rltmsk/src/sous-vide-diaries/1-pork-chop/index.html",
				"isAbsolute": false
			},
			"requirePath": "1-pork-chop/index.html",
			"path": "/1-pork-chop/",
			"data": {
				"title": "Pork Chop, Carrots and Romesco",
				"date": "\"2016-09-07\"",
				"featuredImage": "1-pork-chop/side.jpg",
				"description": "Pork chop with carrots and Romesco. Pre seared, sous vide at 144 and finished with a torching from the searzall.",
				"body": "<!--\ntitle: Pork Chop, Carrots and Romesco\ndate: \"2016-09-07\"\nfeaturedImage: 1-pork-chop/side.jpg\ndescription: Pork chop with carrots and Romesco. Pre seared, sous vide at 144 and finished with a torching from the searzall.\n-->\n<section class='article'>\n  <div class='article-image'>\n    <img src='./side.jpg' />\n  </div>\n  <div class='article-text'>\n    <h1>Pork Chop, Carrots and Romesco</h1>\n    <p class='date'>09 07 2016</p>\n    <p class='description'>Pork chop with carrots and Romesco. Pre seared, sous vide at 144 and finished with a torching from the searzall.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./pan.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Pre-sear</h2>\n    <p class='description'>The pre-sous vide sear helps to start developing both a better texture and more rich flavor.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./cooking.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Cook Sous Vide</h2>\n    <p class='description'>Cook the pork chop at 144f/62.2c for 60-90 minutes. Adding oil to the bag helps the meat cook more evenly and also adds flavor. A great trick for people without chamber sealers is to use cold butter. It won't get sucked out and make a mess of your sealer.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./overhead.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Serve</h2>\n    <p class='description'>Before serving, make sure the meat is entirely dry and then apply another very fast sear with a serzall for texture and improved color.</p>\n  </div>\n</section>\n"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2-ribeye",
				"base": "index.html",
				"ext": "html",
				"name": "index",
				"extname": ".html",
				"basename": "index.html",
				"dirname": "2-ribeye",
				"stem": "index",
				"path": "2-ribeye/index.html",
				"absolute": "/Users/rltmsk/src/sous-vide-diaries/2-ribeye/index.html",
				"isAbsolute": false
			},
			"requirePath": "2-ribeye/index.html",
			"path": "/2-ribeye/",
			"data": {
				"title": "Dry Aged Ribeye",
				"date": "\"2016-09-17\"",
				"featuredImage": "2-ribeye/serve.jpg",
				"description": "1.3lb dry aged beef ribeye. Pre-seared, cooked sous vide and then torched.",
				"body": "<!--\ntitle: Dry Aged Ribeye\ndate: \"2016-09-17\"\nfeaturedImage: 2-ribeye/serve.jpg\ndescription: 1.3lb dry aged beef ribeye. Pre-seared, cooked sous vide and then torched.\n-->\n<section class='article'>\n  <div class='article-image'>\n    <img src='./serve.jpg' />\n  </div>\n  <div class='article-text'>\n    <h1>Dry Aged Ribeye</h1>\n    <p class='date'>09 17 2016</p>\n    <p class='description'>1.3lb dry aged beef ribeye. Pre-seared, cooked sous vide and then torched.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./salted.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Season</h2>\n    <p class='description'>Seasoned with a mixture of Maldon smoked sea salt, kosher salt and fresh ground black pepper.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./sear.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Pre-sear</h2>\n    <p class='description'>The pre-sous vide sear helps to start developing both a better texture and more rich flavor.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./in-bag.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Vacuum Seal</h2>\n    <p class='description'>Vacuum sealing with butter in the bag will help add flavor and evenly cook the meat.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./sous-vide.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Cook Sous Vide</h2>\n    <p class='description'>Cook for 90 minutes at 127f.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./searzall.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Sear with torch</h2>\n    <p class='description'>Searing the meat with a torch develops a nice crust without cooking the meat more.</p>\n  </div>\n</section>\n\n<section class='article'>\n  <div class='article-image'>\n    <img src='./cut.jpg' />\n  </div>\n  <div class='article-text'>\n    <h2>Serve</h2>\n    <p class='description'>Optionally cut, and then serve.</p>\n  </div>\n</section>\n"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/rltmsk/src/sous-vide-diaries/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 364
 ** module chunks = 0
 **/